import React, { useContext } from 'react'
import AwesomeError from 'components/Common/AwesomeError'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import BodyText from 'components/Luxkit/Typography/BodyText'
import ContactContext from 'contexts/contactContext'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextButton from 'components/Luxkit/Button/TextButton'
import TextLink from 'components/Luxkit/TextLink'

interface Props {
  className?: string;
  canSwitchToHotel?: boolean;
}

function OfferCalendarNoFlightsMessage(props: Props) {
  const dispatch = useOfferPageDispatch()
  const currentContact = useContext(ContactContext)

  const onClick = () => {
    dispatch({ type: OfferPageActions.setFlights, flights: false })
  }

  return (
    <AwesomeError title="No flights available" className={props.className}>
      <VerticalSpacer gap={32}>
        <BodyText variant="large">
          Unfortunately we couldn’t find any flights for the travel dates you selected. Try selecting new travel dates or give our flights team a call on {' '}
          <div>
            <TextLink
              href={`tel:${currentContact.local.number}`}
              rel="nofollow"
              wrap="no-wrap"
            >
              {currentContact.local.humanReadable}
            </TextLink>
          </div>
        </BodyText>
        {props.canSwitchToHotel && <TextButton kind="primary" onClick={onClick}>
          View hotel only prices
        </TextButton>}
      </VerticalSpacer>
    </AwesomeError>
  )
}

export default React.memo(OfferCalendarNoFlightsMessage)
